import Vue from 'vue'
const toString = Object.prototype.toString

/*
 * 遍历对象
 *
 * @obj {Object} 要遍历的对象
 * @fn  {Function(value, key)}  遍历的回调
 *
 */

export const mapObject = (obj, fn) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      fn(obj[key], key)
    }
  }
}

/*
 * 函数防抖
 *
 * @action {Function} 要执行的动作
 * @delay  {Number}  执行动作的延迟时间
 * @return {Function} 包装后的动作
 *
 */

export const bounce = function (action, delay) {
  let timer

  return function (...arg) {
    const context = this
    clearTimeout(timer)

    timer = setTimeout(function () {
      action.apply(context, arg)
    }, delay)
  }
}

export const throttle = function (action, duration) {
  let begin = new Date()

  return function () {
    const context = this
    const args = arguments
    const current = new Date()

    if (current - begin >= duration) {
      action.apply(context, args)
      begin = current
    }
  }
}

export const methodsProxy = function (targetInstance, originalInstance, methodsMap) {
  methodsMap.forEach(methodName => {
    const method = originalInstance[methodName]

    if (method && typeof method === 'function') {
      if (targetInstance[methodName]) {
        console.error(`Error in methodsProxy：方法名${methodName}已存在于目标实例中`)
        return
      }

      targetInstance[methodName] = method
    }
  })
}

export const eventsProxy = function (targetInstance, originalInstance, eventsMap) {
  eventsMap.forEach(eventName => {
    if (!originalInstance._events[eventName]) {
      originalInstance._events[eventName] = []
    }

    originalInstance._events[eventName].push(function (...arg) {
      targetInstance.$emit(eventName, ...arg)
    })
  })
}

export const getEmptyObject = function () {
  return {}
}

export const getEmptyArray = function () {
  return []
}

export const deepCopy = (data) => JSON.parse(JSON.stringify(data))

export const noop = () => {}

export const isArray = (target) => {
  return toString.call(target) === '[object Array]'
}

export const isObject = (target) => {
  return toString.call(target) === '[object Object]'
}

export const isPromise = (target) => {
  return toString.call(target) === '[object Promise]'
}

export const isString = (target) => {
  return toString.call(target) === '[object String]'
}

export const isNumber = function (val) {
  let isNumberRes = true

  if (Number.isNaN(val)) {
    isNumberRes = false
  } else if (typeof val !== 'number') {
    isNumberRes = false
  }

  return isNumberRes
}

export const isUndefined = (target) => {
  return toString.call(target) === '[object Undefined]'
}

export const isNull = (target) => {
  return toString.call(target) === '[object Null]'
}

export const isFunction = (target) => {
  return toString.call(target) === '[object Function]'
}

export const isEmpty = (target) => {
  if (isUndefined(target) || isNull(target)) {
    return true
  } else if (isString(target)) {
    return target.trim().length === 0
  } else if (isObject(target)) {
    return Object.keys(target).length === 0
  } else if (isArray(target)) {
    return target.length === 0
  }
  return false
}

export const getDate = () => {
  let now = new Date()
  return `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`
}

export const getLocation = () => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(param => {
        resolve(param)
      })
    } else {
      reject(new Error('get location fail'))
    }
  })
}

export const preArrayMultiple = (srcArr, column = 3, defaultValue = {}) => {
  let bigArr = []
  srcArr.forEach((el, i) => { // 把大数组分割成多个数组，每个数组有n项
    let index = parseInt(i / column)
    bigArr[index] = bigArr[index] ? bigArr[index] : []
    bigArr[index].push(el)
  })
  let last = bigArr.length - 1
  while (bigArr[last] && bigArr[last].length < column) { // 把最后一数组填满n项
    bigArr[bigArr.length - 1].push(defaultValue) // 默认填充
  }
  return bigArr
}

// 根据key从数组中筛选对象
export const findObjFromArray = (arr, key, keyName) => {
  return arr.find(item => item[keyName] === key)
}

export const observable = Vue.observable || ((target) => new Vue({
  data: target
}))

export function importAll(map, r) {
  r.keys().forEach(key => {
    const mapKey = key.split('/').pop().split('.').shift()

    map[mapKey] = r(key)
  })
}
